import { Phone } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import type { CampaignContact } from '../../api/campaigns'
import { formatPhone } from '../../lib/utils'

interface CampaignUpcomingQueueProps {
  contacts: CampaignContact[]
  /** ID of the current contact being called (excluded from the list) */
  currentContactId?: number
}

export function CampaignUpcomingQueue({ contacts, currentContactId }: CampaignUpcomingQueueProps) {
  const { t } = useTranslation('campaigns')
  const upcoming = contacts.filter((c) => c.id !== currentContactId)

  if (upcoming.length === 0) return null

  return (
    <div className="rounded-lg border border-border bg-surface-card p-4">
      <h3 className="text-sm font-semibold text-text-primary">{t('runner.upNext')}</h3>
      <ul className="mt-3 divide-y divide-border">
        {upcoming.map((contact, i) => (
          <li key={contact.id} className="flex items-center gap-3 py-2.5 first:pt-0 last:pb-0">
            <div className="flex h-7 w-7 items-center justify-center rounded-full bg-surface-elevated text-xs font-medium text-text-muted">
              {i + 1}
            </div>
            <div className="min-w-0 flex-1">
              <p className="truncate text-sm font-medium text-text-primary">
                {contact.name || t('runner.unknown')}
              </p>
              <p className="flex items-center gap-1 text-xs text-text-muted">
                <Phone className="h-3 w-3" />
                {formatPhone(contact.phone)}
              </p>
            </div>
          </li>
        ))}
      </ul>
    </div>
  )
}
